import { Env } from '@nio-pow/mfe-vue3'

const allConfigs = require('../../config')

const curAppConfigs = allConfigs[Env.getAppType()]
const curEnvConfig = curAppConfigs[Env.getEnv()]

// 获取当前环境对应的环境配置
export default curEnvConfig
